import { render, staticRenderFns } from "./fakeChart.vue?vue&type=template&id=2e4bb905&scoped=true&"
import script from "./fakeChart.vue?vue&type=script&lang=js&"
export * from "./fakeChart.vue?vue&type=script&lang=js&"
import style0 from "./fakeChart.vue?vue&type=style&index=0&id=2e4bb905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4bb905",
  null
  
)

export default component.exports